import $ from 'jquery';

export const isFormatSelectedFromSelect = () => {
  const selectValue = $('#formats-select').val();
  if (selectValue !== null) {
    $('.swal2-confirm').attr('disabled', false);
    return true;
  } else {
    $('.swal2-confirm').attr('disabled', true);
  }
};
